<script>
    import { fly } from "svelte/transition";
    import { Carousel } from "../index";
    const items = [
        {
            image: "https://via.placeholder.com/750x200/1677ff/ffffff?text=1",
            target: {
                title: "test",
                url: "",
            },
            stat: "ins_ins_item_banner_1",
        },
        {
            image: "https://via.placeholder.com/750x200/ff8f1f/ffffff?text=2",
            target: {
                title: "test",
                url: "",
            },
            stat: "ins_ins_item_banner_1",
        },
        {
            image: "https://via.placeholder.com/750x200/00b578/ffffff?text=3",
            target: {
                title: "test",
                url: "",
            },
            stat: "ins_ins_item_banner_1",
        },
        {
            image: "https://via.placeholder.com/750x200/ff3141/ffffff?text=4",
            target: {
                title: "test",
                url: "",
            },
            stat: "ins_ins_item_banner_1",
        },
    ];

    const items2 = [
        {
            image: "https://via.placeholder.com/750x600/1677ff/ffffff?text=1",
            target: {
                title: "test",
                url: "",
            },
            stat: "ins_ins_item_banner_1",
        },
        {
            image: "https://via.placeholder.com/750x600/ff8f1f/ffffff?text=2",
            target: {
                title: "test",
                url: "",
            },
            stat: "ins_ins_item_banner_1",
        },
        {
            image: "https://via.placeholder.com/750x600/00b578/ffffff?text=3",
            target: {
                title: "test",
                url: "",
            },
            stat: "ins_ins_item_banner_1",
        },
        {
            image: "https://via.placeholder.com/750x600/ff3141/ffffff?text=4",
            target: {
                title: "test",
                url: "",
            },
            stat: "ins_ins_item_banner_1",
        },
    ];
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body nopadding">
        <Carousel {items} />
    </div>
    <h4 class="example-title">自动播放</h4>
    <div class="example-body nopadding">
        <Carousel {items} autoplay />
    </div>
    <h4 class="example-title">显示指示器</h4>
    <div class="example-body nopadding">
        <Carousel {items} autoplay indicator />
    </div>
    <h4 class="example-title">自定义样式</h4>
    <div class="example-body nopadding">
        <Carousel {items} autoplay indicator --border-radius="12px" />
    </div>
    <h4 class="example-title">竖向</h4>
    <div class="example-body nopadding">
        <Carousel items={items2} indicator autoplay direction="vertical" />
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .nopadding {
        padding: 0;
    }
</style>
